"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParameters = void 0;
function getUrlParameters(prefix) {
    var searchParams = new URLSearchParams(window.location.search);
    var map = new Map();
    searchParams.forEach(function (value, name) {
        if (value && value !== 'undefined' && name.startsWith(prefix)) {
            map.set(name.replace(prefix, ''), value);
        }
    });
    return map;
}
exports.getUrlParameters = getUrlParameters;
//# sourceMappingURL=urlParameters.js.map